// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1jgqc","filesListContainer":"PosDisputesFiles_filesListContainer__2htc8","filesButton":"PosDisputesFiles_filesButton__3agTy"};